import { Box, Picture, RatioContainer } from "@jewlr/storybook/core"
import React from "react"
import styled from "styled-components"

import { jewlr_t } from "helpers/application"
import { SectionDescription, SectionTitle } from "jewlr/pages/components"

const PositionBlock = styled.div`
  position: absolute;
  text-align: center;
  top: 30px;
  width: 100%;
  z-index: 1;
  ${(props) => props.theme.mediaQueries.tablet`
    bottom: auto;
    margin: 0;
    left: 8%;
    top: 50%;
    transform: translateY(-50%);
    width: 260px;
  `}
  ${(props) => props.theme.mediaQueries.desktop`
    left: 8%;
    width: 350px;
  `}
`

const MainBanner = () => (
  <RatioContainer
    mb={{ _: 4, desktop: 6 }}
    pb={{ _: "125.16%", tablet: "41.59%", widescreen: "21.77%" }}
  >
    <div>
      <Box
        display={{ tablet: "flex" }}
        height="100%"
        justifyContent="center"
        position="relative"
      >
        <Picture
          fallback={`${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-him/main-banner/desktop_2x.jpg`}
          lazyload={false}
          srcSet={[
            {
              media: "(max-width: 767px)",
              sizes: "100vw",
              srcSet: `
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-him/main-banner/mobile.jpg 767w,
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-him/main-banner/mobile_2x.jpg 1534w
            `,
            },
            {
              media: "(min-width: 768px) and (max-width: 1279px)",
              sizes: "100vw",
              srcSet: `
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-him/main-banner/tablet.jpg 1005w,
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-him/main-banner/tablet_2x.jpg 2010w
            `,
            },
            {
              media: "(min-width: 1280px)",
              sizes: "100vw",
              srcSet: `
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-him/main-banner/desktop.jpg 1920w,
              ${sl.config.jewlr_asset_url}images/homepage/jewlr/collections-for-him/main-banner/desktop_2x.jpg 3840w
            `,
            },
          ]}
        />
        <Box contain height="100%" position="absolute" top="0" width="100%">
          <PositionBlock>
            <SectionTitle
              as="h1"
              fontSize={{ _: "30px", tablet: "34px" }}
              light
              lineHeight={1.2}
              mb={{ _: 1, tablet: 4 }}
            >
              {jewlr_t("terms.Jewelry")}
              <Box as="br" display={{ _: "none", tablet: "block" }} /> For Him
            </SectionTitle>
            <SectionDescription fontSize={{ _: "16px", tablet: "18px" }}>
              {jewlr_t("terms.Personalized")} {jewlr_t("terms.jewelry")} and
              <br />
              accessories just for him.
            </SectionDescription>
          </PositionBlock>
        </Box>
      </Box>
    </div>
  </RatioContainer>
)

export default MainBanner
